import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getUiState = ({ ui }: RootState) => ui;

export const themeSelector = createSelector([getUiState], ({ theme }) => theme);
export const uploadProgressSelector = createSelector([getUiState], ({ fileUpload }) => fileUpload);
